/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CustomerRoleService,
  type Wealthlane_CustomerService_Dtos_CustomerRole_CustomerRoleDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { resolveTenantScope } from '../../constants/tenantScope';
import { refreshSystemRolesTable } from '@apps/customer/domains/system-roles/refreshSystemRolesTable';

const usePostSystemRoles = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  Wealthlane_CustomerService_Dtos_CustomerRole_CustomerRoleDto | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      const scope = resolveTenantScope(payload.scope);
      if (id != null && id !== '') {
        return await handleRequest(
          CustomerRoleService.putApiCustomerApiAppCustomerRoleCustomerRole({
            ...payload,
            id,
            scope,
          })
        );
      }
      return await handleRequest(
        CustomerRoleService.postApiCustomerApiAppCustomerRoleCustomerRole({
          ...payload,
          scope,
        })
      );
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          refreshSystemRolesTable();
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Role ${id != null && id !== '' ? 'edited' : 'added'}`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSystemRoles;
